import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AuthService } from "../../modules/authentication/services/auth.service";
import { AuthStatus } from "../../modules/authentication/interfaces/auth-status.enum";


export const privateGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  if (auth.authStatus() !== AuthStatus.authenticated) {
    inject(Router).navigateByUrl('/login');
    return false;
  }
  return true;
};

export const publicGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  if (auth.authStatus() === AuthStatus.authenticated) {
    inject(Router).navigateByUrl('/home');
    return false;
  }
  return true;
};
